import { colorTextWarning } from 'component/color';
import { RichText } from 'component/richtext';
import { checkValidLength } from 'component/text';
import { useCallback } from 'react';
import type { TLabel } from 'util/stdtypes';
import { t } from 'util/stdtypes';

import { QUESTION_MAX_NAME_LENGTH, QUESTION_MIN_NAME_LENGTH } from './constants';

type RichErrorMessageProps = {
    error: TLabel;
    formatParams?: Record<string, string>;
};

export function RichErrorMessage({ error, formatParams }: RichErrorMessageProps) {
    return <RichText color={colorTextWarning} formatParams={formatParams} label={error} type='small' />;
}

export function useQuestionNameValidation(setError: (error: JSX.Element | undefined) => void) {
    const handleValidation = useCallback(
        (value: string) => {
            if (value.length === 0) {
                setError(<RichErrorMessage error={t('The prompt cannot be empty.')} />);
            } else if (!checkValidLength({ text: value, min: QUESTION_MIN_NAME_LENGTH, max: QUESTION_MAX_NAME_LENGTH })) {
                setError(
                    <RichErrorMessage
                        error={t('The prompt must be fewer than {num} characters.')}
                        formatParams={{ num: QUESTION_MAX_NAME_LENGTH.toString() }}
                    />,
                );
            } else {
                setError(undefined);
            }
        },
        [setError],
    );
    return handleValidation;
}
